import "../../../assets/presentation/components/modal-views/modal-view-BSqlXgaL.css";
import { BlockingView } from "../layout/blocking-view/blocking-view2.js";
/* empty css           */
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/modal-views/modal-view.tsx
var ModalView = forwardRef(({ className, children, style }, ref) => /* @__PURE__ */ jsx("div", {
	ref,
	className: classNames(className, "modal-view"),
	style,
	children
}));
var ModalViewAnchor = ({ className, children, onClick, ...otherProps }) => /* @__PURE__ */ jsx("div", {
	...otherProps,
	className: classNames(className, "anchor"),
	onClick,
	children
});
var ModalViewContainer = ({ className, children, isPending, loadingText, style, onClickOutside, ...otherProps }) => /* @__PURE__ */ jsx(BlockingView, {
	...otherProps,
	className: classNames(className, "container"),
	isPending,
	loadingText,
	style,
	onClickOutside,
	component: "div",
	children
});
var ModalViewLayout = ({ className, children, style, ...otherProps }) => /* @__PURE__ */ jsx("div", {
	...otherProps,
	className: classNames(className, "layout"),
	style,
	children
});
var ModalViewScrim = ({ className, onClick, children }) => /* @__PURE__ */ jsx("div", {
	className: classNames(className, "scrim"),
	onClick,
	children
});
//#endregion
export { ModalView, ModalViewAnchor, ModalViewContainer, ModalViewLayout, ModalViewScrim };

//# sourceMappingURL=modal-view2.js.map